<div class="home-cards" style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; justify-content: center; align-items: center; max-width: 800px; margin: 0 auto; padding: 2rem; height: 80vh;">
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('machine-list')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Machines</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-list" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>Manage your machines</p>
    </div>
  </p-card>
  <p-card [style]="{width: '380px', cursor: 'pointer', padding: '2rem'}" (click)="navigateTo('pending-sessions')">
    <ng-template pTemplate="header">
      <h2 style="text-align: center; margin: 0;">Pending Sessions</h2>
    </ng-template>
    <div style="text-align: center;">
      <i class="pi pi-box" style="font-size: 2rem; margin-bottom: 1rem;"></i>
      <p>View and connect to your sessions</p>
    </div>
  </p-card>
</div>
